import React from 'react';
import {AccessControlIndicator} from '@igp/shared/access-control';
import type {
    IBulkApplyStrategy,
    IBulkStrategy,
    PerformStrategyOperationResponse,
    PerformStrategyRequest,
    ValidationStrategyResponse,
} from '@igp/shared/features/bulk-operation';
import type {BaseBulkP2PTransferProps} from '@igp/shared/features/transaction';
import {
    type ApplyP2PTransfersRequest,
    BulkP2PTransferButton as BaseBulkP2PTransferButton,
    type LoadP2PTransferStrategyRequest,
    type LoadP2PTransferStrategyResponse,
    type P2PTransferModel,
    type ValidationP2PTransferRequest,
} from '@igp/shared/features/transaction';
import {useService} from '@igp/shared/ioc-container';
import {EntityType} from '@models';

import {ServiceTypes} from '@ioc-container';
import {withAccessCheck} from '@access-control';
import {agentResources} from '@policy-access';

type BulkP2PTransferButton = BaseBulkP2PTransferProps & {
    uids: string[];
};

function BulkP2PTransferButtonInner(props: BulkP2PTransferButton) {
    const loadP2PTransfersStrategy = useService<IBulkStrategy<LoadP2PTransferStrategyRequest, LoadP2PTransferStrategyResponse>>(
        ServiceTypes.LoadP2PTransferStrategy
    );
    const applyP2PTransfersStrategy = useService<IBulkApplyStrategy<ApplyP2PTransfersRequest>>(ServiceTypes.ApplyP2PTransfersStrategy);
    const validationP2PTransferStrategy = useService<IBulkStrategy<ValidationP2PTransferRequest, ValidationStrategyResponse>>(
        ServiceTypes.ValidationP2PTransferStrategy
    );
    const performP2PTransfersStrategy = useService<
        IBulkStrategy<PerformStrategyRequest<P2PTransferModel>, PerformStrategyOperationResponse>
    >(ServiceTypes.PerformP2PTransfersStrategy);
    return (
        <BaseBulkP2PTransferButton
            {...props}
            p2pSettingsEntityType={EntityType.P2PPlayerSettings}
            bulkOperationEntityType={EntityType.BulkOperation}
            loadP2PTransfersStrategy={loadP2PTransfersStrategy}
            applyP2PTransfersStrategy={applyP2PTransfersStrategy}
            validationP2PTransferStrategy={validationP2PTransferStrategy}
            performP2PTransfersStrategy={performP2PTransfersStrategy}
        />
    );
}

export const BulkP2PTransferButton = withAccessCheck(BulkP2PTransferButtonInner, agentResources, AccessControlIndicator.Disabled);
